<template>
  <p
    class="
      $color/alpha:54%
      $typography/size:medium
      typography
    "
    >
    <span
      v-if="filteredTotal === 0 && searchVal.length > 0">
      {{ messageSearchTermNoResults }}
    </span>
    <span
      v-else-if="filteredTotal === total"
      v-html="messageTotalCountOnline"
    />
    <span v-else>
      <span
        v-if="filteredTotal === 0"
        v-html="messageFilteredNoCount"
      />
      <span
        v-else
        v-html="messageFilteredCount"
      />
      <a
        :data-gtm="dataGtm"
        :href="href"
        @click.prevent="$emit('resetForm')"
        v-html="messageTotalCount"
      />
      <span v-html="labelOnline" />
    </span>
  </p>
</template>

<script>
  /**
   * FilterCount
   *
   * A dynamic text component that shows messages of the format:
   *  - messageFilteredCount = <span "Showing FILTERED_COUNT out of"><a TOTAL_COUNT RESOURCE><span "online">
   *  - messageFilteredNoCount = <span "No results out of"><a TOTAL_COUNT RESOURCE><span "online">
   *  - messageSearchTermNoResults = <span "No results for 'SEARCHVAL'">
   *  - messageTotalCountOnline = <span "TOTAL_COUNT RESOURCE online">
   *
   * TODO: Create a component that can create formatted linkified sentence better.
   */
  export default {
    props: {
      dataGtm: { type: String, required: false, default: "" },
      filteredTotal: { type: Number, required: true },
      href: { type: String, required: false, default: "" },
      labelOnline: { type: String, required: true },
      messageFilteredCount: { type: String, required: true },
      messageFilteredNoCount: { type: String, required: true },
      messageSearchTermNoResults: { type: String, required: true },
      messageTotalCount: { type: String, required: true },
      messageTotalCountOnline: { type: String, required: true },
      searchVal: { type: String, required: false, default: ""},
      total: { type: Number, required: true },
    },
  };
</script>
